/* One absolute deadline per product; never restart the timer on reload. */
(() => {
  if (window.joviProductPromotionReady) return;
  window.joviProductPromotionReady = true;
  const active = new Set();
  let interval;
  const pad = value => String(value).padStart(2, '0');
  function tick() {
    const now = Date.now();
    active.forEach(element => {
      const deadline = Number(element.dataset.promoDeadline) * 1000;
      const remaining = Math.ceil((deadline - now) / 1000);
      const clock = element.querySelector('[data-promo-clock]');
      if (!element.isConnected || !Number.isFinite(deadline) || remaining <= 0 || !clock) {
        element.hidden = true;
        active.delete(element);
        return;
      }
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining % 86400 / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      clock.textContent = `${days ? days + 'd ' : ''}${pad(hours)}h ${pad(minutes)}m ${pad(remaining % 60)}s`;
      element.hidden = false;
    });
    if (!active.size && interval) { clearInterval(interval); interval = null; }
  }
  function init() {
    document.querySelectorAll('[data-promo-deadline]').forEach(element => active.add(element));
    tick();
    if (active.size && !interval) interval = setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', tick);
  document.addEventListener('visibilitychange', tick);
})();
